var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{attrs:{"title":_vm.title,"width":"900px","top":"8vh","modal":true,"visible":_vm.status},on:{"update:visible":function($event){_vm.status=$event}}},[_c('div',{staticClass:"vfWrap"},[_c('CreateClass',{ref:"clsRef",on:{"onSuccess":_vm.onSuccess}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }